export default __webpack_public_path__ + "static/bed_b.11e08cbdf44051f7062f967cae34f599.png";